import { FileViewer } from "@/components/features/matter/file-repo/FileViewer";
import { Button } from "@/components/ui";
import type { Matter } from "@/lib/types";
import { Plus } from "lucide-react";
import {
  getHeroImage,
  getMatterFileName,
  getMatterFilePresignedUrlKey,
} from "../matter-overview-utils";
export function HeroImageCard({
  matter,
  onAddPhoto,
}: {
  matter: Matter;
  onAddPhoto: () => void;
}) {
  const heroImage = getHeroImage(matter);
  const heroImagePresignedUrlKey = heroImage
    ? getMatterFilePresignedUrlKey(heroImage)
    : "";

  if (!heroImage || !heroImagePresignedUrlKey) {
    return (
      <div className="bg-muted flex h-[250px] w-[250px] items-center justify-center rounded-2xl border">
        <div className="flex flex-col items-center gap-3">
          <span className="text-muted-foreground text-sm">No photo</span>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onAddPhoto}
          >
            <Plus className="mr-2 h-4 w-4" />
            Add photo
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[250px] w-[250px] overflow-hidden rounded-2xl border">
      <FileViewer
        fileType="matter-file"
        file={{
          fileName: getMatterFileName(heroImage),
          presignedURLKey: heroImagePresignedUrlKey,
        }}
        imageClassName="h-[250px] w-[250px] object-cover"
        imageLoadingClassName="h-[250px] w-[250px]"
        fileInWrapper={false}
        showDownload={false}
        showTitle={false}
        footerClassName="hidden"
      />
    </div>
  );
}
